import _ from 'underscore';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';
import { withContextualAttributeTemplate } from '@bingads-webui-campaign/recommendation-contextual-attribute';
import { CONTEXTUAL_ENTITY_TYPE } from '@bingads-webui-campaign/recommendation-core';

export class GoogleImportToDoColumn extends ProjectionGridBaseColumn {
  constructor({ i18n, isMCC }) {
    const title = i18n.getString('ColumnName_WhatYouCanDo') || '__what you can do__';
    super({
      name: 'googleImportToDo',
      property: 'GoogleImportToDo',
      title,
      bodyClasses: ['grid-column-whatyoucando'],
      colClasses: ['col-superLongText'],
      type: 'string',
      helpAriaLabel: i18n.getString('Click to learn more about {{item}}', { item: title }),
    });
    this.i18n = i18n;
    this.isMCC = isMCC;
  }

  template({
    value: {
      Opportunities,
      Target: {
        AccountName,
        AccountId,
      },
    },
  }) {
    const { i18n, isMCC } = this;
    const accountName = withContextualAttributeTemplate({
      opportunityId: Opportunities[0].OpportunityId,
      entityName: AccountName,
      entityId: AccountId,
      entityType: CONTEXTUAL_ENTITY_TYPE.ACCOUNT,
      status: 'false',
    });
    return isMCC ?
      i18n.getString('Recommendation_Grid_GoogleImportOpportunity_Todo_Title_MCC', { accountName }) :
      i18n.getString('Recommendation_Grid_GoogleImportOpportunity_Todo_Title');
  }

  get property() {
    return {
      get: _.identity,
      property: 'Target/AccountNameMCC',
    };
  }
}
